'use strict';

const React = require('react');
const PropTypes = require('prop-types');

const BuyerAssuranceIcon = require('dibs-vg/dist/react/buyer-assurance');
const { buyerGuarantee, tradeGuarantee } = require('../../../../../json/copy/buyerAssurance.json');
const { trackEvent } = require('dibs-tracking');
const styles = require('./BuyerAssurance-style.scss');

const BuyerAssurance = ({ isVerifiedTrade, vertical }) => {
    const copy = isVerifiedTrade && vertical === 'furniture' ? tradeGuarantee : buyerGuarantee;
    const trackLinkClick = () => {
        trackEvent({
            action: 'buyer protection',
            label: 'clicked',
            category: 'product',
            value: 0,
        });
    };

    return (
        <div className="pdp-sidebar-icon buyer-assurance-container" data-tn="buyer-protection">
            <div className={`${styles.icon} buyer-assurance-icon`}>
                <BuyerAssuranceIcon />
            </div>
            <div className={styles.info}>
                <span className={styles.title}>{copy.title}:</span>
                <span className={styles.text}> {copy.text}</span>
                <div className={styles.link}>
                    <a href={copy.link} target="_blank" onClick={trackLinkClick}>
                        {' '}
                        Learn more
                    </a>
                </div>
            </div>
        </div>
    );
};

BuyerAssurance.propTypes = {
    isVerifiedTrade: PropTypes.bool,
    vertical: PropTypes.string,
};

module.exports = BuyerAssurance;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/BuyerAssurance/BuyerAssurance.jsx